import { Injectable } from '@angular/core'

@Injectable()
export abstract class CalculationResultResetCalculationDao {
  abstract resetCalculation(planId: number): Promise<void>
}
